import { DefaultUrlSerializer, UrlSerializer, UrlTree } from '@angular/router';

import sanitizeTelNumber from '../../../shared/src/util/tel-handler.util';

export class CustomUrlSerializer implements UrlSerializer {
  private defaultSerializer = new DefaultUrlSerializer();

  parse(url: string): UrlTree {
    for (const scheme of ['tel', 'callto']) {
      const prefix = `${scheme}:`;
      const index = url.indexOf(prefix);
      if (index !== -1) {
        const before = url.slice(0, index + prefix.length);
        const number = url.slice(index + prefix.length);
        const sanitizedNumber = sanitizeTelNumber(number);
        return this.defaultSerializer.parse(before + sanitizedNumber);
      }
    }

    return this.defaultSerializer.parse(url);
  }

  serialize(tree: UrlTree): string {
    return this.defaultSerializer.serialize(tree);
  }
}
